import Link from "next/link";
import { CSSProperties } from "react";
import { _ } from "../../../services/text-services";
// @ts-ignore
import styles from "./breadcrumbs.module.scss";

export interface CrumbBase {
  text: string;
  href?: string;
  isSecondaryColor?: boolean;
}

interface Crumb extends CrumbBase {
  active?: boolean;
}
function Crumb({ href, text, active, isSecondaryColor }: Crumb) {
  return (
    <>
      {!text ? (
        <></>
      ) : active ? (
        <li
          className={`${styles["breadcrumb-item"]} ${
            isSecondaryColor ? styles["secondary-color"] : ""
          }`}

          style={{display:"flex", flexWrap:"wrap"}}
        >
          <Link prefetch={false} href={href ?? "#"}>
            <a role="button">{_(text)}</a>
          </Link>
        </li>
      ) : (
        <li
          className={`${styles["breadcrumb-item"]} ${
            isSecondaryColor ? styles["secondary-color"] : ""
          }`}
          style={{display:"flex", flexWrap:"wrap"}}
        >
          <span>{text}</span>
        </li>
      )}
    </>
  );
}

interface BreadcrumbsProps {
  crumbs: CrumbBase[];
  activeLast?: boolean;
  customstyle?: CSSProperties;
  isSecondaryColor?: boolean;
}
function Breadcrumbs({
  crumbs,
  activeLast = true,
  customstyle,
  isSecondaryColor = false
}: BreadcrumbsProps) {
  return (
    <ul className={styles.breadcrumb} style={customstyle}>
      {crumbs.map((crumb, index) => (
        <Crumb
          key={`crumb-${index}`}
          isSecondaryColor={isSecondaryColor}
          active={activeLast ? activeLast : crumbs.length !== index + 1}
          {...crumb}
        />
      ))}
    </ul>
  );
}

export default Breadcrumbs;
